<script setup lang="ts">
import { useRodoStore } from '@/domains/rodo/store/useRodoStore.ts'
import { useRodoTitle } from '@/domains/rodo/composables/useRodoTitle'
import RodoInfo from '@/domains/rodo/components/rodoInfo.vue'

const Topics = defineAsyncComponent(() => import('@/domains/rodo/components/Topics/Topics.vue'))
const HasProduct = defineAsyncComponent(() => import('@/domains/rodo/components/hasProduct/hasProduct.vue'))
const Form = defineAsyncComponent(() => import('@/domains/rodo/components/Form/Form.vue'))

const { step, topic } = useRodoStore()
const { titles } = useRodoTitle()

const title = computed(() => {
  if (step.value === 0 || step.value === 1) {
    return titles[step.value].title
  }

  return titles[topic.value as keyof typeof titles].title
})

const subtitle = computed(() => {
  if (step.value === 0 || step.value === 1) {
    return titles[step.value].subtitle
  }
  return titles[2].subtitle
})
</script>

<template>
  <div class="supportRodoPage">
    <div class="supportRodoPage__formContainer">
      <div class="supportRodoPage__column">
        <h1 class="supportRodoPage__formTitle">
          {{ title }}
        </h1>

        <p class="supportRodoPage__subtitle">
          {{ subtitle }}
        </p>

        <Transition
          name="fade"
          mode="out-in"
        >
          <Topics v-if="step === 0" />

          <HasProduct v-else-if="step === 1" />

          <Form v-else />
        </Transition>
      </div>
  
      <div class="supportRodoPage__column">
        <RodoInfo />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .supportRodoPage {
    padding: 0 2.4rem;
    padding-top: 6.4rem;
    background-color: $gray-100;

  &__formContainer {
    margin-top: 3.2rem;
    padding: 2.4rem 0;
  }

  &__formTitle {
    @include h8;

    margin-bottom: 1.6rem;
    color: $text-500;
    text-align: center;
  }

  &__subtitle {
    @include h9;
    margin-bottom: 3.2rem;

    color: $text-300;
    text-align: center;
  }

  @include atS {
    &__formContainer {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
  }

  @include atL {
    padding-top: 8.6rem;

    &__stepsWrapper {
      justify-content: space-between;
    }
      
    &__formContainer {
      display: flex;
      max-width: 152rem;
      margin: auto;
      padding: 6.4rem;
      column-gap: 2.4rem;
    }

    &__column {
      flex: 1;
    }
  }
}
</style>
